import { mapDtoToGlobal } from "../models/map";
import { strapiClient } from "./strapi-client";
import { cached } from "./ttl-cache";

/**
 * Шапка, меню, футер и баннер одинаковы для всех страниц, но запрашивались на
 * каждый запрос и занимали от 0.5 до 1.5 с прямо в TTFB. Минута здесь дольше,
 * чем s-maxage страниц (15 с): шапка, меню и футер меняются редко, а вебхук
 * из Strapi на /api/revalidate сбрасывает этот кэш сразу после правки.
 */
const GLOBAL_TTL_MS = 60_000;

const fetchGlobal = async () => {
  const response = await strapiClient.single("global").find({
    populate: {
      header: {
        populate: {
          headerNav: {
            populate: {
              categories: {
                populate: {
                  routes: {
                    populate: { media: true, mediaMobile: true },
                  },
                },
              },
            },
          },
          menuButtons: {
            populate: {
              icon: true,
            },
          },
          ctaButton: {
            populate: {
              pageIcon: {
                populate: {
                  icon: {
                    populate: "*",
                  },
                  uicon: {
                    populate: "*",
                  },
                },
              },
            },
          },
        },
      },
      footer: {
        populate: {
          newsletterPersonalDataPolicy: {
            populate: {
              documentPage: {
                populate: "*",
              },
              documentFile: {
                populate: {
                  file: true,
                },
              },
            },
          },
          socialLinks: {
            populate: {
              icon: {
                populate: "*",
              },
            },
          },
          footerNav: {
            populate: {
              categories: {
                populate: {
                  routes: {
                    populate: { media: true },
                  },
                },
              },
            },
          },
          info: true,
          footerBottom: {
            populate: {
              documents: {
                populate: {
                  documentPage: {
                    populate: "*",
                  },
                  documentFile: {
                    populate: {
                      file: true,
                    },
                  },
                },
              },
            },
          },
        },
      },
      feedbackForm: {
        populate: {
          privacyPolicy: {
            populate: {
              documentPage: {
                populate: "*",
              },
              documentFile: {
                populate: {
                  file: true,
                },
              },
            },
          },
          privacyPolicyAlt: {
            populate: {
              documentPage: {
                populate: "*",
              },
              documentFile: {
                populate: {
                  file: true,
                },
              },
            },
          },
        },
      },
      seo: {
        populate: {
          ogImage: {
            populate: "*",
          },
        },
      },
      musicTrack: {
        populate: {
          file: {
            populate: "*",
          },
        },
      },
      weather: true,
      alertBanner: {
        populate: "*",
      },
    },
  });

  return mapDtoToGlobal(response);
};

export const getGlobal = () => cached("global", GLOBAL_TTL_MS, fetchGlobal);
